import $ from 'jquery'
import Feature from 'ol/Feature'
import { extend } from 'ol/extent'
/**
 * @param {Object} config
 * @constructor
 */
export default function SearchResultDropdown(config) {
  $.extend(this, config || {})

  this.ul = $('.navbar-right ul:first')
  this.li = $('<li id="resultList" class="dropdown"></li>')

  this.title = $('<span></span>')
  this.icon = $('<i class="glyphicon glyphicon-tree-conifer"></i>')
  this.caret = $(' <span class="caret"></span>')
  this.link = $('<a class="dropdown-toggle" data-toggle="dropdown"></a>')
  this.link.appendTo(this.li)
  this.icon.appendTo(this.link)
  this.title.appendTo(this.link)
  this.caret.appendTo(this.link)

  this.dropdown = $('<ul class="dropdown-menu" role="menu"></ul>')
  this.dropdown.appendTo(this.li)

  this.link.on('click', () => {
    this.li.toggleClass('open')
  })

  this.onSelecTrigger = this.autoSearch.api.autoSearch.createTrigger('select')

  this.li.prependTo(this.ul)
}

/**
 * Clean up resources
 */
SearchResultDropdown.prototype.dispose = function() {
  this.li.remove()
}

/**
 * Set features to be presented
 * @param {Array.<Feature>} features
 */
SearchResultDropdown.prototype.setFeatures = function(features) {
  const sort = this.autoSearch.sort !== undefined ? this.autoSearch.sort : true
  const menuItemFeatures = [...features]
  if (sort) {
    menuItemFeatures.sort((f1, f2) =>
      f1.get(this.displayField).localeCompare(f2.get(this.displayField), 'sv')
    )
  }

  menuItemFeatures.forEach(this.generateMenuItem.bind(this))
  if (this.autoSearch.viewAllOption) {
    this.createViewAllOption(features)
  }
}

/**
 * Create All-feature choice
 * @param {Array.<Feature>} features
 */
SearchResultDropdown.prototype.createViewAllOption = function(features) {
  var item = $('<li><a role="menuitem" tabindex="-1" >' + 'Alla' + '</a></li>')
  this.title.text('Alla')
  item.on('click', _ => {
    this.autoSearch.zoomToMany(features)
    this.title.text('Alla')
    this.li.removeClass('open')
    this.onSelecTrigger(features)
  })
  item.prependTo(this.dropdown)
}

/**
 * Set title
 * @param {Feature} feature
 */
SearchResultDropdown.prototype.setTitle = function(feature) {
  this.title.text(feature.get(this.displayField))
}

/**
 * Generate menu item from feature
 * @param {Feature} feature
 * @param {number} index
 */
SearchResultDropdown.prototype.generateMenuItem = function(feature, index) {
  if (index === 0 && !this.autoSearch.viewAllOption) {
    this.setTitle(feature)
  }

  var item = $(
    '<li><a role="menuitem" tabindex="-1" >' +
      feature.get(this.displayField) +
      '</a></li>'
  )

  item.on('click', this.onItemClick.bind(this))

  item.get(0).feature = feature
  item.appendTo(this.dropdown)
}

/**
 * Zoom to clicked item feature
 * @param {Object} e
 */
SearchResultDropdown.prototype.onItemClick = function(e) {
  var item = e.currentTarget
  var feature = item.feature
  this.onSelecTrigger(feature)
  this.setTitle(feature)
  this.autoSearch.zoomTo(feature)
  this.li.removeClass('open')
}
